module.exports = __webpack_public_path__ + "img/257.40278aa4.png";